// extracted by mini-css-extract-plugin
export var breadcrumb = "_n-0";
export var breadcrumbArrow = "_n-1";